export const AccordionData = [
    {
      question: 'Popular Tests',
      isActive: true,
      content: [
        { answer: 'CRP Test', url: 'https://oncquestlabs.com/test/crp-c-reactive-protein-qualitative' },
        { answer: 'Liver Function Test(Lft)', url: 'https://oncquestlabs.com/test/liver-function-test-lft' },
        { answer: 'Kidney Function Test (Kft)', url: 'https://oncquestlabs.com/test/kidney-function-test-kft' },
        { answer: 'Lipid Profile Test', url: 'https://oncquestlabs.com/test/lipid-profile-basic' },
        { answer: 'CBC Test', url: 'https://oncquestlabs.com/test/cbc-complete-blood-count' },
        { answer: 'Hba1C Test', url: 'https://oncquestlabs.com/test/hba1c-glycosylated-haemoglobin' },
        { answer: 'Cholesterol Test', url: 'https://oncquestlabs.com/test/total-cholesterol' },
        { answer: 'Vitamin D Test', url: 'https://oncquestlabs.com/test/vitamin-d-25-hydroxy' },
        { answer: 'Vitamin B12 Test', url: 'https://oncquestlabs.com/test/vitamin-b12-active-holo-transcobalamin' },
        { answer: 'CA125 Test', url: 'https://oncquestlabs.com/test/ca125-cancer-antigen-125' },
        { answer: 'HBsAg Test', url: 'https://oncquestlabs.com/test/hbsag-screen-qualitative' },
      ],
    },
    // {
    //   question: 'Location',
    //   isActive: false,
    //   content: [
    //     { answer: 'Lab Test in Bengaluru', url: 'https://oncquestlabs.com/pathology-test/bengaluru' },
    //     { answer: 'Lab Test in Bhatinda', url: 'https://oncquestlabs.com/pathology-test/bhatinda ' },
    //     { answer: 'Lab Test in Bhopal', url: 'https://oncquestlabs.com/pathology-test/bhopal ' },
    //     { answer: 'Lab Test in Bhubaneswar ', url: 'https://oncquestlabs.com/pathology-test/bhubaneswar' },
    //     { answer: 'Lab Test in Cuttack ', url: 'https://oncquestlabs.com/pathology-test/cuttack' },
    //     { answer: 'Lab Test in Delhi ', url: 'https://oncquestlabs.com/pathology-test/delhi' },
    //     { answer: 'Lab Test in Gurugram', url: 'https://oncquestlabs.com/pathology-test/gurugram ' },
    //     { answer: 'Lab Test in Guwahati', url: 'https://oncquestlabs.com/pathology-test/guwahati ' },
    //     { answer: 'Lab Test in Hyderabad ', url: 'https://oncquestlabs.com/pathology-test/hyderabad' },
    //     { answer: 'Lab Test in Jalandhar ', url: 'https://oncquestlabs.com/pathology-test/jalandhar' },
    //     { answer: 'Lab Test in Jhansi', url: 'https://oncquestlabs.com/pathology-test/jhansi ' },
    //     { answer: 'Lab Test in Kanpur', url: 'https://oncquestlabs.com/pathology-test/kanpur ' },
    //     { answer: 'Lab Test in Kolkata ', url: 'https://oncquestlabs.com/pathology-test/kolkata' },
    //     { answer: 'Lab Test in Lucknow ', url: 'https://oncquestlabs.com/pathology-test/lucknow' },
    //     { answer: 'Lab Test in Ludhiana', url: 'https://oncquestlabs.com/pathology-test/ludhiana ' },
    //     { answer: 'Lab Test in Mumbai', url: 'https://oncquestlabs.com/pathology-test/mumbai ' },
    //     { answer: 'Lab Test in Nashik', url: 'https://oncquestlabs.com/pathology-test/nashik ' },
    //     { answer: 'Lab Test in Panchkula ', url: 'https://oncquestlabs.com/pathology-test/panchkula' },
    //     { answer: 'Lab Test in Patna ', url: 'https://oncquestlabs.com/pathology-test/patna' },
    //     { answer: 'Lab Test in Pune', url: 'https://oncquestlabs.com/pathology-test/pune ' },
    //     { answer: 'Lab Test in Raipur', url: 'https://oncquestlabs.com/pathology-test/raipur ' },
    //     { answer: 'Lab Test in Srinagar', url: 'https://oncquestlabs.com/pathology-test/srinagar ' },
    //     { answer: 'Lab Test in Varanasi', url: 'https://oncquestlabs.com/pathology-test/varanasi ' },
    //   ],
    // },
  ];